import React, { useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import ReactECharts from 'echarts-for-react';

const allChannels = [
    { type: 'Share', label: 'Share Link' },
    { type: 'qr', label: 'QR Codes' },
    { type: 'Teams', label: 'Teams' },
    { type: 'Facebook', label: 'Facebook' },
    { type: 'LinkedIn', label: 'LinkedIn' },
    { type: 'Twitter', label: 'X' }
];

const ChannelsChart = ({ data }) => {
    const ref = useRef(null);
    const theme = useTheme();
    const padding = theme.spacing(3);
    const chartHeight = 400;

    const channelData = allChannels.map(e => {
        const posts = data.find(c => c.type === e.type && c.label.toLowerCase().includes('post'))?.total ?? 0;
        const opens = data.find(c => c.type === e.type && c.label.toLowerCase().includes('open'))?.total ?? 0;
        const clicks = data.find(c => c.type === e.type && c.label.toLowerCase().includes('click'))?.total ?? 0;

        return [e.label, posts, opens, clicks];
    });

    const options = {
        animationDuration: 500,
        grid: {
            left: theme.spacing(6),
            top: theme.spacing(5),
            right: padding,
            bottom: padding
        },
        legend: {},
        tooltip: {},
        dataset: {
            source: [
                ['Channel', 'Posts', 'Opens', 'Clicks'],
                ...channelData
            ]
        },
        minInterval: 1,
        xAxis: { type: 'category' },
        yAxis: {
            axisLine: {
                show: true
            }
        },
        // Declare several bar series, each will be mapped to a column of dataset.source by default.
        series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
    };

    return (
        <ReactECharts
            option={options}
            style={{ height: chartHeight }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default ChannelsChart;